'use strict';
module.exports = require('./Password.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/password/index.js
// module id = 124
// module chunks = 1